/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AdSearchSchemaV2 = {
    properties: {
        sortBy: {
            type: 'AdSortEnum',
            isRequired: true,
        },
        sortOrder: {
            type: 'SortEnum',
            isRequired: true,
        },
        startDate: {
            type: 'any-of',
            contains: [{
                type: 'DateRange',
            }, {
                type: 'null',
            }],
        },
        stopDate: {
            type: 'any-of',
            contains: [{
                type: 'DateRange',
            }, {
                type: 'null',
            }],
        },
        active: {
            type: 'any-of',
            contains: [{
                type: 'boolean',
            }, {
                type: 'null',
            }],
        },
        position: {
            type: 'array',
            contains: {
                type: 'AdPositionEnum',
            },
        },
        name: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        areaOfInterestIds: {
            type: 'array',
            contains: {
                type: 'number',
            },
        },
        paused: {
            type: 'any-of',
            contains: [{
                type: 'boolean',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
